import React, { useEffect, useState } from "react";
import CardInfo from "../../components/cards/cardInfo";
import DivisionCmp from "../../components/cards/DivisionCmp";

import { Box, Grid } from "@mui/material";
import { Formik } from "formik";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CustomisedButton from "../../components/button/button";
import TwoColumnCard from "../../components/cards/TwoColumnCard";
import ShowErrorsModal from "../../components/modals/showErrorsModal";
import TableCreator from "../../components/table/tableCreator";
import LoadDocumentCmp from "../../components/thumbnail/loadDocumentCmp";
import { SALE_ITEM } from "../../config/cacheKey";
import { ColumnModel } from "../../models/common.model";
import {
  IDeleteInvoiceFileRequest,
  IGetByKeyResponse,
  IInvoiceFiles,
  ISaleItemRequest,
  IUploadInvoiceFileRequest,
  IWaitForConfirmRequestRequest,
} from "../../models/sale.model";
import { ErrorsTab } from "../../models/supplierSettlement/supplierSettlement.model";
import {
  deleteInvoiceFile,
  getByKey,
  uploadInvoiceFile,
} from "../../services/sale.service";
import "./sale.css";
// const [attachments, setAttachments] = useState<IInvoiceFiles[]>([]);

export default function SaleFactorDetail() {
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = React.useState<IGetByKeyResponse>();
  const [error, setError] = React.useState([] as ErrorsTab[]);
  const [factorNumber, setFactorNumber] = React.useState();
  const [invoiceFile, setInvoiceFile] = useState<IInvoiceFiles[]>([]);
  const queryClient = useQueryClient();
  const columns: readonly ColumnModel[] = [
    { id: "saleItemGroupTitle", label: "گروه کالا" },
    { id: "title", label: " عنوان کالا" },
    { id: "quantity", label: " مقدار (عدد)" },
    {
      id: "saleItemTotalAmount",
      label: " مبلغ کل (ريال)",
      hasFormat: true,
      format: (value: number) => {
        return value?.toLocaleString("fa");
      },
    },
  ];
  const table = (
    <Box paddingX={{ xs: "0.25rem", md: "1.25rem" }}>
      <TableCreator
        columns={columns}
        data={data?.saleItems}
        pageInfo={undefined}
        // handleChangePagination={handleChangePagination}
        // currentPaginationInfo={currentPaginationInfo}
      />
    </Box>
  );

  const handleShowError = () => {
    setOpenModal(true);
  };
  interface IGetSaleId {
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }
  const history = useHistory<IGetSaleId>();

  let request = JSON.parse(
    localStorage.getItem(SALE_ITEM)!
  ) as ISaleItemRequest | null;

  useEffect(() => {
    GetByKeyMutate({
      saleKey: request?.saleKey!,
      branchId: request?.branchId!,
      customerPersonId: request?.customerPersonId!,
    });
  }, []);
  const { mutate: GetByKeyMutate } = useMutation(getByKey, {
    onSuccess: (data: IGetByKeyResponse) => {
      if (data) {
        setData(data);
        setInvoiceFile(data.invoiceFiles);
      }
    },
  });

  const returnButton = () => {
    history.goBack();
    // history.push({
    //   pathname: "/financial/waitForSettlementByCustomer",
    //   state: {
    //     //   from: "",
    //     //   id: branchId,
    //     //   pageNumber: currentPaginationInfo.pageNumber!,
    //     //   clickOnBack: false,
    //     saleKey: request?.saleKey!,
    //     branchId: request?.branchId!,
    //     customerPersonId: request?.customerPersonId!,
    //   },
    // });
  };

  return (
    <div>
      <CardInfo
        customerFullName={data?.customerFullName}
        customerMobileNumber={data?.customerMobileNumber}
        customerWalletAmount={data?.customerWalletAmount}
        expirationDate_Persian={data?.expirationDate_Persian}
        saleDate_Persian={data?.saleDate_Persian}
        issuanceInvoiceDate_Persian={data?.issuanceInvoiceDate_Persian}
        confirmInvoiceDate_Persian={data?.confirmInvoiceDate_Persian}
        branchAddress={data?.branchAddress}
        saleType={data?.saleType}
        saleTypeTitle={data?.saleTypeTitle}
        branchTitle={data?.branchTitle}
        storeTitle={data?.storeTitle}
        storeUrl={data?.storeUrl}
      />
      <div className="mTop30">
        <DivisionCmp title="کالاهای درخواستی" child={table} />
      </div>
      <Grid
        container
        columns={{ xs: 4, sm: 8, md: 12 }}
        className="mTop30"
        style={{ width: "99%", margin: "0 auto" }}
        spacing={2}
      >
        <Grid item xs={6} sm={12} md={6}>
          <DivisionCmp
            title="جزییات پرداخت"
            child={
              <Box
                className="p-8"
                // style={{ maxHeight: "21.5rem", height: "21.5rem" }}
                maxHeight={{ xs: "unset", lg: "23.5rem" }}
                minHeight={{ xs: "unset", lg: "23.5rem" }}
                overflow="auto"
              >
                <TwoColumnCard
                  saleAmount={data?.saleAmount!}
                  cashAmount={data?.cashAmount!}
                  creditAmount={data?.creditAmount!}
                  customerWalletAmount={data?.customerWalletAmount!}
                  totalSettlementAmount={data?.totalSettlementAmount!}
                  saleItemsFeeAmount={data?.saleItemsFeeAmount!}
                  repaymentFeeAmount={data?.repaymentFeeAmount!}
                  supplierSideLoanFeeAmount={data?.supplierSideLoanFeeAmount!}
                  taxAmount={data?.taxAmount!}
                />
              </Box>
            }
          />
        </Grid>
        <Grid item xs={6} sm={12} md={6}>
          <DivisionCmp
            style={{ height: "378px", minHeight: "378px", maxHeight: "378px" }}
            title="مستندات فاکتور"
            child={
              invoiceFile ? (
                <div className="p-1">
                  <PaymentConfirmation
                    setFactorNumber={setFactorNumber}
                    invoiceFile={invoiceFile}
                    setInvoiceFile={setInvoiceFile}
                    request={request!}
                  />
                </div>
              ) : (
                <div>
                  <div>
                    <img
                      style={{ margin: "auto", marginBottom: "2vh" }}
                      // className="designCard divisionCardTitle"
                      src={`images/emptyFactor.svg`}
                      alt="فاکتور"
                    />
                  </div>
                  <span style={{ color: "#C1C7CB", fontSize: "16px" }}>
                    .مستنداتی برای{" "}
                    <span style={{ fontWeight: "bold" }}>فاکتور</span> ثبت نشده
                    است.
                  </span>
                </div>
              )
            }
            minHeight="26.8rem"
            textAlign="center"
            alignItems="center"
            display="grid"
          />
        </Grid>
      </Grid>
      <ShowErrorsModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        validationMessages={error}
        firstPartOfTitle=" درخواست تسویه حساب به دلایل زیر"
        boldTitle="پذیرفته"
        secondPartOfTitle="نشد.جهت ویرایش به بخش های مربوطه مراجعه کنید."
      />
      <Grid
        container
        style={
          {
            // margin: "35vh 0 10px 30px",
          }
        }
      >
        <Grid item xs={6}></Grid>
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            paddingInline: "18px",
            width: "100%",
          }}
        >
          <CustomisedButton
            title={"بازگشت"}
            disable={false}
            onClick={returnButton}
            type="submit"
          />
        </Grid>
      </Grid>
    </div>
  );
}

const PaymentConfirmation = ({
  setFactorNumber,
  invoiceFile,
  setInvoiceFile,
  request,
}: {
  setFactorNumber: React.Dispatch<React.SetStateAction<any>>;
  invoiceFile: IInvoiceFiles[];
  setInvoiceFile: React.Dispatch<React.SetStateAction<IInvoiceFiles[]>>;
  request: ISaleItemRequest;
}) => {
  const [number, setNumber] = useState();

  const validationFatcorNumber = Yup.object().shape({
    inquiryOtp: Yup.string()
      .required("فیلد اجباری است.")
      .matches(/^[0-9]+$/, "کد استعلامی عدد می باشد."), //.min(5).max(5)
  });
  async function handleChoosedImage(image: any) {
    let maxSize = 1024;
    if (maxSize === undefined) {
      maxSize = 1024 * 1000;
    }

    if (image.data.size != null && image.data.size > maxSize) {
      toast.error(" سایز فایل مورد نظر بیشتر از اندازه مجاز است.");
      return;
    } else {
      const uploadInvoiceFileObj = {} as IUploadInvoiceFileRequest;
      uploadInvoiceFileObj.saleKey = request.saleKey;
      uploadInvoiceFileObj.branchId = request.branchId;
      uploadInvoiceFileObj.customerPersonId = request.customerPersonId;
      uploadInvoiceFileObj.file = image.data;
      uploadInvoiceFileMutation(uploadInvoiceFileObj);
    }
  }
  async function handleOnFileChoosed(files: any) {
    files.map(async (item: any, idx: any) => {
      let maxSize = 1024;
      if (maxSize === undefined) {
        maxSize = 1024 * 1000;
      }
      //convert KB to Byte--> size returns byte of size
      if (item.size != null && item.size > maxSize) {
        toast.error(" سایز فایل مورد نظر بیشتر از اندازه مجاز است.");
        return;
      } else {
        let fileObj = {} as IInvoiceFiles;
        fileObj.fileUrl = files.dataurl;
        fileObj.fileName = files.data.name;
        fileObj.fileId = files.fileId;
        let uploadFile = [...invoiceFile, fileObj];
        setInvoiceFile(uploadFile);
        const uploadInvoiceFileObj = {} as IUploadInvoiceFileRequest;
        uploadInvoiceFileObj.saleKey = request.saleKey;
        uploadInvoiceFileObj.branchId = request.branchId;
        uploadInvoiceFileObj.customerPersonId = request.customerPersonId;
        uploadInvoiceFileObj.file = item;
        uploadInvoiceFileMutation(uploadInvoiceFileObj);
      }
    });
  }
  const setChildValue = (childValues: any) => {
    setInvoiceFile(childValues);
  };
  let uploadFile: IInvoiceFiles[] = [];
  const { mutate: uploadInvoiceFileMutation } = useMutation(uploadInvoiceFile, {
    onSuccess: (data: IInvoiceFiles) => {
      if (data) {
        if (data !== null && data !== undefined) {
          let fileObj = {} as IInvoiceFiles;
          fileObj.fileUrl = data.fileUrl;
          fileObj.fileName = data.fileName;
          fileObj.fileId = data.fileId;
          if (invoiceFile !== null) {
            uploadFile = [...invoiceFile, fileObj];
          } else {
            uploadFile.push(fileObj);
          }
          setInvoiceFile(uploadFile);
        }
      }
    },
  });

  const handleChangeFactorNumber = (e: any) => {
    if (e.target?.value !== undefined && e.target?.value !== null) {
      setFactorNumber(e.target?.value!);
      setNumber(e.target?.value!);
    }
  };
  return (
    <Formik
      validateOnMount={true}
      initialValues={{} as IWaitForConfirmRequestRequest}
      validationSchema={validationFatcorNumber}
      onSubmit={async (values) => {}}
    >
      {({
        handleSubmit,
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
      }) => (
        <form
          onSubmit={handleSubmit}
          style={{
            maxWidth: "50rem",
            margin: "0px auto",
            maxHeight: "21rem",
            overflowY: "hidden",
            overflowX: "auto",
          }}
        >
          <Grid container xs={12}>
            <Grid container xs={12} style={{ overflow: "auto" }}>
              <Grid
                item
                xs={6}
                width={{ xs: "200px", lg: "unset" }}
                className="horizontalScroll"
              >
                {invoiceFile !== null && invoiceFile?.length > 0
                  ? invoiceFile?.map((item: any) => {
                      return (
                        <div
                          style={{
                            minWidth: "23vh",
                            maxWidth: "23vh",
                            display: "inline-block",
                          }}
                        >
                          <LoadDocumentCmp
                            data={item}
                            setChildValue={setChildValue}
                            serviceName={deleteInvoiceFile}
                            cacheName={undefined}
                            serviceRequestObj={
                              {
                                saleKey: request.saleKey,
                                branchId: request.branchId,
                                customerPersonId: request.customerPersonId,
                                fileId: item.fileId,
                              } as IDeleteInvoiceFileRequest
                            }
                            attachments={invoiceFile}
                            multiItem={true}
                            picName={"picName"}
                            dontShowDeleteIcon={true}
                          />
                        </div>
                      );
                    })
                  : null}
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};
